import React, { useState, useEffect } from "react";
import "./App.css";
import github from "./github.png";
import discord from "./discord.png";
import instagram from "./instagram.png";

function App() {
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [showText, setShowText] = useState("");
  const [isTypingComplete, setTypingComplete] = useState(false);

  const textLines = [
    "Passionate about competitive programming, software engineering, and web development,",
    "with a strong desire to continuously expand my knowledge.",
    "Proficient in Python, JavaScript, Ruby, and a little bit of Rust and C++.",
    "Eager to collaborate on innovative projects that emphasize teamwork and creativity!",
  ];

  useEffect(() => {
    if (index < textLines.length) {
      const currentLine = textLines[index];
      if (typeof currentLine === "string") {
        if (charIndex < currentLine.length) {
          const interval = setInterval(() => {
            setShowText((prev) => prev + currentLine[charIndex]);
            setCharIndex(charIndex + 1);
          }, 50);
          return () => clearInterval(interval);
        } else {
          setTimeout(() => {
            setIndex(index + 1);
            setCharIndex(0);
            setShowText((prev) => prev + "\n");
          }, 500);
        }
      }
    } else {
      setTypingComplete(true);
    }
  }, [index, charIndex]);

  return (
    <div className="Root">
      <div className="Username">@wildanrfq</div>
      <div className="Content">
        <p className="Name">Wildan Rifqi</p>
        <div className="Body typewriter">
          <div className="TextWithCursor">
            {showText}
            {!isTypingComplete && <span className="cursor">|</span>}
          </div>
        </div>
      </div>
      <br />
      <div className="Lastfm">
        {isTypingComplete && (
          <a href="https://last.fm/user/wildanrfq">
            <img
              width="350"
              src="https://lastfm-recently-played.vercel.app/api?user=wildanrfq&loved=true&loved_style=3&count=1&show_user=header&bg_color=22303c&border_radius=50"
            ></img>
          </a>
        )}
      </div>
      <div id="Logos">
        <a
          href="https://github.com/wildanrfq"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={github} alt="GitHub" />
        </a>
        <a
          href="https://discord.com/users/211756205721255947"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={discord} alt="Discord" />
        </a>
        <a
          href="https://instagram.com/wildanrfq"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={instagram} alt="Instagram" className="instagram" />
        </a>
      </div>
      <footer>
        © 2024 <a href="https://wildanrfq.github.io">@wildanrfq</a>
      </footer>
    </div>
  );
}

export default App;
